import { makeLink } from "./links";
import ENCopy from "./copy.en";
import { labelOptions } from "./consoleOptions";
import { urls } from "./urls";
import { get } from "svelte/store";

// French
const minimumAge = 18;

const copy = (): ReturnType<typeof ENCopy> => ({
  urls,
  prizeNames: {
    operatorSkin: "APPARENCE D'OPÉRATEUR",
    operatorSkinSplit: "APPARENCE <br> D'OPÉRATEUR",
    operatorSkinS: "APPARENCE <br> D'OPÉRATEUR",
    codPoints: "POINTS <i>CALL OF DUTY</i>",
    emblem: "EMBLÈME",
    charm: "PORTE-BONHEUR",
    callingCard: "CARTE DE VISITE",
    plus: "DE PLUS ",
    youCanWin: "VOUS POUVEZ GAGNER DES PASSES DE COMBAT ET DES POINTS <i>CALL OF DUTY</i>!",
    youCanWinSplit: "VOUS POUVEZ GAGNER <br> DES PASSES DE COMBAT <br> ET DES POINTS <i>CALL OF DUTY</i>!",
    firstPurchase: "Premier Achat:",
    secondPurchase: "Deuxième Achat:",
    thirdPurchase: "Troisième Achat:",
    oneInGameEmblem: "(1) Emblème dans le Jeu",
    oneInGameCharm: "(1) Porte-bonheur dans le Jeu",
    oneInGameCallingCard: "(1) Carte de Visite dans le Jeu",
    oneInGameOperatorSkin: "(1) Apparence d'Opérateur dans le Jeu"
  },
  error: {
    generic: {
      title: "ERREUR",
      subtitle: "Une erreur inconnue s'est produite.",
      retryButton: "Réessayer"
    },
    invalidEntry: {
      title: "ERREUR",
      subtitle: "LE CODE OU LE REÇU QUE VOUS AVEZ SAISIS EST INVALIDE. VEUILLEZ RÉESSAYER ET ASSUREZ-VOUS DE SUIVRE LES DIRECTIVES.",
      info: `Si vous rencontrez toujours des problèmes et pensez que votre participation devrait être éligible, veuillez contacter le ${makeLink(get(urls).contactUs, "Service Client")}.`,
      retryButton: "Réessayer"
    },
    unlucky: {
      title: "ERREUR",
      subtitle: "Nous n'avons pas pu déverrouiller votre récompense pour l'une des raisons suivantes :",
      renderActivisionErrorDetails: true,
      retryButton: "Réessayer"
    },
    unableToValidateReceipt: {
      title: "ERREUR",
      subtitle: "NOUS N'AVONS PAS PU VALIDER VOTRE ENTRÉE POUR LE MOMENT. VEUILLEZ RÉESSAYER PLUS TARD.",
      retryButton: "Réessayer"
    },
    underage: {
      title: "ERREUR",
      subtitle: `Vous devez être âgé d'au moins ${minimumAge} ans pour participer.`,
    },
    alreadyParticipatedToday: {
      title: "ERREUR",
      subtitle: "Vous avez déjà soumis une participation aujourd'hui. Veuillez revenir demain."
    },
    unsupportedCountry: {
      title: "ERREUR",
      subtitle: "Cette promotion n'est pas disponible dans votre pays.",
      info: `Cette promotion n'est disponible que pour les résidents légaux des États-Unis, du Canada (sauf le Québec) et du Mexique. Veuillez vérifier plus tard pour les promotions futures qui pourraient être disponibles dans votre région.`,
    },
    campaignNotSupported: {
      title: "ERREUR",
      subtitle: "Cette promotion n'est pas disponible dans votre pays.",
      info: `Cliquez ci-dessous pour visiter la campagne prise en charge.`,
      retryButton: "Participer"
    }
  },
  common: {
    unlock: "DÉVERROUILLEZ",
    dual2xp: "LE DUAL 2XP",
  },
  header: {
    menus: {
      orderFromLittleCaesars: "COMMANDER CHEZ LITTLE CAESARS<sup>®</sup>",
      chooseYourLanguage: "CHOISIR VOTRE LANGUE"
    },
    ariaLabels: {
      logo: "Logo de Little Caesars",
      menuButton: "Ouvrir le menu de navigation"
    }
  },
  countrySelector: {
    title: "SÉLECTIONNEZ VOTRE PAYS",
    placeholder: "Choisir pays",
    confirmButton: "CONFIRMER"
  },
  teaser: {
    title: "RENDEZ COMPTE <br> PLUS TARD",
    subtitle: "CETTE PROMOTION ARRIVE BIENTÔT. <br> REVENEZ LE 3 NOVEMBRE"
  },
  over: {
    title: "MISSION <br> COMPLÉTÉE",
    subtitle: "CETTE PROMOTION EST TERMINÉE."
  },
  prizes: {
    mobileTitleClasses: "text-[50px] mobileS:text-[60px] mobile:text-[90px] tablet:text-[84px]",
    title: "RÉCOMPENSES <br> ET PRIX",
    subtitle: "DÉCOUVREZ CE QUE <br> VOUS POURRIEZ GAGNER!"
  },
  activisionErrorDetails: {
    reasons: [
      "Vous avez atteint le maximum de 40 heures de contenu bonus XP sur votre compte. Une fois ce statut atteint, vous ne pouvez plus recevoir de jetons XP supplémentaires.",
      "Votre compte Activision n'est pas lié à un compte de jeu. Veuillez vous assurer que votre compte Activision est lié à un compte de jeu pour obtenir la récompense."
    ],
    contactSupport: `Si aucune des raisons ci-dessus ne s'applique, veuillez contacter le ${makeLink(get(urls).activisionSupport, "support d'Activision")} pour obtenir de l'aide supplémentaire.`
  },
  registration: {
    title: "LES RÉCOMPENSES <br> EN JEU SONT <br> DE RETOUR",
    subtitle: "INSCRIVEZ-VOUS MAINTENANT!",
    limitedToThreeTotalQualifyingPurchases: "(Limité à TROIS ACHATS admissibles au total)",
    requiredField: "Champs requis",
    selectCountry: "Veuillez sélectionner votre pays de résidence:",
    consolePreference: "Gaming Console Preference for&nbsp;<i>Call of Duty: Black Ops 7</i>",
    consolePreferencePlaceholder: "Gaming Console Preference for Call of Duty: Black Ops 7",
    consolePreferenceOptions: labelOptions({
      xbox: "Xbox®",
      playstation: "PlayStation®",
      battleNet: "Battle.net",
      steam: "Steam®",
      microsoftStore: "Xbox® on PC"
    }),
    notGuaranteed: "L'obtention du prix Call of Duty : Black Ops 7 n'est pas garantie.",
    firstNameLabel: "Prénom",
    lastNameLabel: "Nom",
    emailLabel: "Adresse courriel",
    dobLabel: "Date de naissance",
    confirmEmailLabel: "Confirmer l'adresse courriel",
    skillLabel: "Résoudre:",
    submitButton: "SOUMETTRE",
    minimumAge,
    ariaLabels: {
      checkboxDescribedBy: "interrupteur de case à cocher",
      submitButton: "Soumettre le formulaire d'inscription"
    },
    validations: {
      invalidSkillAnswer: "Réponse invalide",
      invalidConsoleOption: "Veuillez choisir une préférence de console de jeu",
      firstNameEmpty: "Veuillez entrer votre prénom",
      firstNameInvalid: "Votre prénom est trop court",
      firstNameContainsIllegalCharacters: "Votre prénom contient des caractères illégaux",
      lastNameEmpty: "Veuillez entrer votre nom de famille",
      lastNameInvalid: "Votre nom de famille est trop court",
      lastNameContainsIllegalCharacters: "Votre nom de famille contient des caractères illégaux",
      emailEmpty: "Veuillez entrer votre adresse e-mail",
      emailInvalid: "Veuillez entrer une adresse e-mail valide",
      dobInvalid: "Veuillez entrer une date de naissance valide",
      dobUnderage: `Vous devez être âgé d'au moins ${minimumAge} ans pour participer`,
      mandatoryCheckbox: "Cette case à cocher est requise pour continuer"
    }
  },
  homepage: {
    titleTextClasses: "text-[50px] mobileS:text-[60px] mobile:text-[78px] tablet:text-[64px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    for: "pour",
    blackOps6: "Call of Duty® : Black Ops 7",
    note: `avec tout achat admissible<span class="reg">*</span> fait chez Little Caesars<span class="reg">®</span>.`,
    bonus: "VOUS POUVEZ GAGNER DES RÉCOMPenses de jeu <br> en prime COMME DES PASSES DE COMBAT <br> ET DES POINTS <i>CALL OF DUTY</i>.",
    entry: {
      label: "VOTRE ADRESSE COURRIEL",
      button: "DÉVERROUILLER DES RÉCOMPENSES",
      info: "Veuillez entrer l'adresse courriel associée à votre compte Activision.",
      rules: `Consultez le ${makeLink(get(urls).officialRules, "règlement officiel")} pour savoir comment participer sans achat.`
    },
    rewardsButton: "VOIR LES RÉCOMPENSES"
  },
  purchaseSelection: {
    titleTextClasses: "text-[50px] mobileS:text-[60px] mobile:text-[78px] tablet:text-[64px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    subtitle: "Sélectionnez comment vous souhaitez entrer votre achat",
    limits: "Soumission  maximale d'un code ou d'un reçu par jour.",
    or: "Ou",
    action: "ENTRER OU TÉLÉVERSER",
    actionCodeSmall: "Entrer",
    actionCode: "ENTRER VOTRE CODE DE REÇU",
    actionCodeDescription: "Si vous avez effectué un achat en restaurant, par le biais du site Web ou l'aide de l'appli et que votre reçu comporte un code unique, entrez ce code ici. ",
    actionUploadSmall: "Téléverser",
    actionUpload: "TÉLÉVERSER VOTRE REÇU D'ACHAT EN RESTAURANT",
    actionUploadDescription: "Si vous avez effectué un achat en restaurant et que votre reçu imprimé ne comporte aucun code, prenez une photo claire de ce reçu complet et téléversez-la ici.",
    checkRules: `Consultez le ${makeLink(get(urls).officialRules, "règlement officiel")} pour savoir comment participer sans achat.`
  },
  code: {
    title: `VOUS AVEZ OBTENU <br class="hidden tablet:block"> UN CODE`,
    subtitle: "VEUILLEZ ENTRER LE CODE UNIQUE FIGURANT SUR VOTRE COURRIEL DE CONFIRMATION DE COMMANDE OU VOTRE REÇU DE LITTLE CAESARS.",
    invalidCode: "Code invalide",
    failedToSaveCode: "Échec de la sauvegarde du code. Veuillez réessayer.",
    label: "ENTRER LE CODE À 7 CHIFFRES",
    button: "SOUMETTRE",
    findCode: "Localisez le code figurant sur votre courriel de confirmation de commande ou votre",
    findCodeLink: "reçu d'achat en restaurant",
    limits: "Soumission maximale d'un code par jour.",
    noCodeTryReceipt: {
      initial: "Aucun code?",
      linked: "Cliquez ici pour téléverser un reçu"
    },
    support: {
      haveCode: "Avez-vous un code de support client?",
      link: "Cliquez ici."
    }
  },
  receipt: {
    titleTextClasses: "text-[40px] mobileS:text-[50px] mobile:text-[84px] tablet:text-[84px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    title: `PARTAGER VOS <br class="hidden tablet:block"> RENSEIGNEMENTS <br class="hidden tablet:block"> MILITAIRES`,
    subtitle: `TÉLÉVERSER UNE PHOTO DE VOTRE REÇU D'UN <br class="block mobile:hidden"> ACHAT DANS UN RESTAURANT LITTLE CAESARS<span class="reg text-[0.7em] align-top">®</span> ICI.`,
    noReceiptTryCode: {
      initial: "Si un code figure au bas de votre reçu,",
      linked: "cliquez ici pour entrer ce code"
    },
    info: `Les reçus téléversés qui affichent un code seront rejetés. <br class="block mobile:hidden"> Soumission maximale d'un reçu par jour.`,
    guidelinesTitle: "DIRECTIVES DE TÉLÉVERSEMENT D'UN REÇU",
    guidelineIntro1: "Veuillez vous assurer de téléverser une photo claire du",
    guidelineIntroLink: "reçu complet",
    guidelineIntro2: "qui contient les renseignements suivants:",
    guidelinesList: [
      "ID unique (numéro de transaction)",
      "Emplacement du Little Caesars (doit être au Mexique ou au Canada [excluant le Québec])",
      "Date d'achat (doit être entre le 03/11/25 et le 31/12/25)",
      "Total partiel de la commande (doit répondre aux exigences d'achat admissible*)",
      "Veuillez inclure un seul reçu par photo"
    ],
    uploadFromDevice: "TÉLÉVERSER DEPUIS VOTRE APPAREIL",
    dragFileToUpload: "FAITES GLISSER POUR TÉLÉVERSER",
    chooseFile: "CHOISIR UN FICHIER",
    continueButton: "SUIVANT",
    rejectedFile: "Votre fichier a été rejeté par le serveur. Assurez-vous qu'il s'agit d'un fichier JPEG ou PNG valide, que sa taille est inférieure à 6 Mo et qu'il respecte les directives.",
    receiptData: {
      completeReceiptInfo: "Complétez les informations de votre reçu",
      orderNumber: "Numéro de Commande",
      orderNumberPlaceholder: "Entrez le numéro de commande",
      orderDate: "Date d'Achat",
      location: "Emplacement Little Caesars",
      locationPlaceholder: "Rechercher l'emplacement de la boutique",
      submitReceipt: "Soumettre le Reçu",
      validations: {
        orderNumberRequired: "Le numéro de commande est requis",
        orderNumberInvalid: "Le numéro de commande doit être un nombre",
        orderDateRequired: "La date d'achat est requise",
        orderDateTooRecent: "La date d'achat est trop récente. Veuillez réessayer plus tard.",
        orderDateInFuture: "La date d'achat ne peut pas être dans le futur",
        orderDateTooOld: "Les reçus doivent être postérieurs au 3 novembre",
        locationRequired: "L'emplacement est requis"
      },
      codeGenerated: {
        message: `Un code a été généré pour ce reçu. Veuillez vérifier votre e-mail et utiliser le code pour échanger votre prix. <br class="hidden tablet:block"> Si vous ne le trouvez pas, veuillez contacter le service client de Little Caesars à ${makeLink(get(urls).contactLittleCaesars, "Contactez-nous - Little Caesars®")}.`,
        linkText: "Cliquez ici pour saisir votre code"
      },
      saveFailedErrorMessage: "Échec de la sauvegarde des informations du reçu. Veuillez réessayer."
    }
  },
  rateLimited: {
    title: "Limite de Taux",
    message: "Vous avez fait trop de tentatives. Veuillez attendre un moment avant de réessayer.",
    ariaCloseButton: "Fermer la modal de limite de taux",
    ariaModalDescription: "Modal de limite de taux"
  },
  verifyModal: {
    closeButtonAriaLabel: "Fermer la modal de vérification",
    modalAriaDescription: "Vérifiez votre numéro de téléphone ou votre courriel",
    title: "Vérifiez votre numéro",
    smsMessage: "Veuillez entrer le code à 6 chiffres qui a été envoyé à votre numéro se terminant par {phoneNumber}.",
    emailMessage: "Veuillez entrer le code à 6 chiffres qui a été envoyé à votre courriel.",
    toggleToEmail: "Préférez-vous vérifier par courriel?",
    toggleToSms: "Préférez-vous vérifier par message texte?",
    toggleLink: "Cliquez ici",
    verifyButton: "Vérifier",
    countdownMessage: "Demander un nouveau code dans {countdown} secondes",
    requestNewCode: "Vous n'avez pas reçu de code? Cliquez ici pour en demander un nouveau.",
    errors: {
      requestFailed: "Échec de la demande de nouveau code de vérification.",
      toggleChannelFailed: "Échec du changement de canal.",
      verificationFailed: "La vérification a échoué. Veuillez réessayer.",
      verificationFinishFailed: "Échec de la finalisation de la vérification... {errorMessage}",
      multipleCallOfDutyIdentities: "L'adresse e-mail que vous essayez d'utiliser est déjà associée à un compte <i>Call of Duty</i> différent."
    }
  },
  reviewReceipt: {
    titleTextClasses: "text-[40px] mobileS:text-[50px] mobile:text-[84px] tablet:text-[84px] laptop:text-[100px] desktop:text-[110px] desktopLg:text-[140px]",
    title: `VÉRIFIER LE PARTAGE <br class="hidden tablet:block"> DE VOS RENSEIGNEMENTS <br class="hidden tablet:block"> MILITAIRES`,
    subtitle: "CONFIRMER LE TÉLÉVERSEMENT DE VOTRE REÇU.",
    flipPhoto: "Retourner la photo",
    info: "Prévisualisez la soumission de votre reçu. Si vous souhaitez le modifier ou soumettre plutôt un autre reçu, cliquez sur PRÉCÉDENT. Sinon, cliquez sur SOUMETTRE pour terminer la procédure de soumission.",
    limits: "Soumission maximale d'un reçu par jour. ",
    receiptPreview: "APERÇU DU REÇU",
    backButton: "PRÉCÉDENT",
    submitButton: "SOUMETTRE"
  },
  thankYou: {
    title: "BIENVENUE <br> PARMI NOUS",
    subtitle: `MERCI DE VOUS JOINDRE À NOUS. <br class="hidden tablet:block"> VOUS AVEZ DÉVERROUILLÉ:`,
    prizeInfo: "Veuillez consulter votre courriel pour plus d'information sur votre récompense.",
    orderAgain: "COMMANDEZ DE NOUVEAU DEMAIN <br> ET DÉVERROUILLEZ PLUS DE RÉCOMPENSES!",
  },
  footer: {
    navItems: {
      rewardsAndPrizes: "Récompenses et prix",
      officialRules: "Règlement officiel",
      faq: "FAQ",
      termsOfService: "Conditions d'utilisation",
      privacyPolicy: "Politique de confidentialité",
      usStatePrivacyPolicy: "US State Privacy Policy",
      contactUs: "Nous contacter",
      nonParticipatingStores: "Boutiques non participantes"
    },
    ariaLabels: {
      navigation: {
        rewardsAndPrizes: "Récompenses et prix s'ouvre dans un nouvel onglet",
        officialRules: "Règlement officiel s'ouvre dans un nouvel onglet",
        faq: "FAQ s'ouvre dans un nouvel onglet",
        termsOfService: "Conditions d'utilisation s'ouvre dans un nouvel onglet",
        privacyPolicy: "Politique de confidentialité s'ouvre dans un nouvel onglet",
        usStatePrivacyPolicy: "US State Privacy Policy s'ouvre dans un nouvel onglet",
        contactUs: "Nous contacter s'ouvre dans un nouvel onglet",
        nonParticipatingStores: "Boutiques non participantes s'ouvre dans un nouvel onglet"
      }
    },
    info: `
      AUCUN ACHAT NÉCESSAIRE. Nul là où la loi l'interdit. Résidents des 50 États-Unis et DC, Canada (excl. Québec) et Mexique, doivent être majeurs.
      Se termine le 31/12/25 (codes doivent être saisis avant le 31/01/2026). 19 653 prix disponibles au début de la promotion (VAD de 4,99 $ à 99,99 $ USD).
      Limite de 1 HEURE de JETON 2XP par jour ; 40 HEURES au total. S'applique à toutes les promotions 2XP pour <i>Call of Duty: Black Ops 7</i>
      (non limité à cette promotion). Les chances dépendent du moment de participation et du nombre. Test de compétences mathématiques requis au Canada et au Mexique.
      ${makeLink(get(urls).officialRules, "Consultez le règlement officiel")}. Commanditaire : Little Caesar Enterprises, Inc.
    `,
    copyright: `
      Classement ESRB : MATURE. Visitez ${makeLink("https://www.esrb.org", "www.esrb.org")}. ©/™/® 2025 Activision Publishing, Inc.
    `,
    pattern: "/assets/images/esrb-fr.svg?v=202511131232"
  }
});

export default copy;
